module.exports = __webpack_public_path__ + "img/GH-kyujin-top-038.c92f6a61.webp";